(() => {
  const DESKTOP_BREAKPOINT = 768;

  const initInlineFacetShell = (shell) => {
    if (!shell || shell.dataset.inlineFacetsInitialized === 'true') return;
    shell.dataset.inlineFacetsInitialized = 'true';

    const detailsElements = Array.from(shell.querySelectorAll('.collection-inline-filter-group'));
    const overlay = shell.querySelector('.collection-inline-overlay');
    if (detailsElements.length === 0) return;

    const closeAll = (exclude = null) => {
      detailsElements.forEach((details) => {
        if (details !== exclude) details.open = false;
      });
    };

    const updateOverlayOffset = () => {
      const toolbar = shell.closest('.collection-toolbar-inline');
      if (!toolbar) return;
      const toolbarBottom = Math.max(0, Math.round(toolbar.getBoundingClientRect().bottom));
      toolbar.style.setProperty('--inline-overlay-offset', `${toolbarBottom}px`);
    };

    const updateOffsetIfOpen = () => {
      if (!shell.classList.contains('is-filter-open')) return;
      updateOverlayOffset();
    };

    const updateOpenStateClass = () => {
      const hasOpenDetails = detailsElements.some((details) => details.open);
      shell.classList.toggle('is-filter-open', hasOpenDetails);
      const toolbar = shell.closest('.collection-toolbar-inline');
      if (toolbar) {
        toolbar.classList.toggle('is-inline-filter-open', hasOpenDetails);
        if (hasOpenDetails) {
          updateOverlayOffset();
        }
      }
    };

    detailsElements.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          closeAll(details); // Keep only one filter panel open at a time.
        }
        updateOpenStateClass();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', () => {
        closeAll();
        updateOpenStateClass();
      });
    }

    document.addEventListener('click', (event) => {
      if (!shell.classList.contains('is-filter-open')) return;
      if (shell.contains(event.target)) return;
      // Keep filter panel open when removing active filters from the toolbar pills.
      if (event.target.closest('#current-facets-ajax') || event.target.closest('[data-remove-single-filter]')) return;
      closeAll();
      updateOpenStateClass();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeAll();
      updateOpenStateClass();
    });

    window.addEventListener('scroll', () => {
      updateOffsetIfOpen();
    }, { passive: true });

    document.addEventListener('woolman:resize', () => {
      updateOffsetIfOpen();
    });

    // Keep panel/overlay offset in sync when toolbar height changes
    // (e.g. active filter tags appear after first selection).
    const toolbar = shell.closest('.collection-toolbar-inline');
    if (toolbar && 'ResizeObserver' in window) {
      const toolbarResizeObserver = new ResizeObserver(() => {
        updateOffsetIfOpen();
      });
      toolbarResizeObserver.observe(toolbar);
    }

    const closeOnMobile = () => {
      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        closeAll();
        updateOpenStateClass();
      }
    };

    closeOnMobile();
    document.addEventListener('woolman:resize', closeOnMobile);
  };

  const initInlineFacets = () => {
    document.querySelectorAll('[data-inline-facets-shell]').forEach(initInlineFacetShell);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInlineFacets);
  } else {
    initInlineFacets();
  }
})();
